import { booleanAttribute, Component, input, model } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";

@Component({
  template: "",
  selector: "component-base-control-value-accessor"
})
export abstract class BaseControlValueAccessorComponent<T> implements ControlValueAccessor {
  readonly _value = model<T | null>(null, { alias: "value" });
  readonly _disabled = model<boolean>(false, {
    alias: "disabled"
  });
  readonly _required = input<boolean, unknown>(false, {
    alias: "required",
    transform: booleanAttribute
  });
  touched = false;

  onChange = (_: any): void => {};
  onTouched = (): void => {};

  writeValue(value: T | null): void {
    // Always update the value, even if it's the same
    // This ensures the component reflects the form control's value
    this._value.set(value);
  }

  // Mark the control as touched
  markAsTouched(): void {
    if (!this.touched) {
      this.touched = true;
      this.onTouched();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled.set(isDisabled);
  }
}
